import "./TranslateChoosedFilters.css";
import { useAtom } from "jotai";
import { 
  useMainFilter,
  useSecondFilter,
  useExperienceFilter,
  useCurrencyFilter,
  useSalaryFilter,
  useCountryFilter
} from "../../data/GlobalStates";

const TranslateChoosedFilters = () => {
  const [MainFilter] = useAtom(useMainFilter);
  const [SecondFilter] = useAtom(useSecondFilter);
  const [ExperienceFilter] = useAtom(useExperienceFilter);
  const [CurrencyFilter] = useAtom(useCurrencyFilter);
  const [SalaryFilter] = useAtom(useSalaryFilter);
  const [CountryFilter] = useAtom(useCountryFilter);

  // Jeśli MainFilter jest pusty → nie pokazujemy nic
  if (!MainFilter || MainFilter.trim() === "") {
    return null;
  }

  // Tworzymy tablicę tylko z tych stanów, które mają wartość
  const headerParts = [
    MainFilter,
    SecondFilter,
    ExperienceFilter,
    CountryFilter
  ].filter(value => value && value.trim() !== "");

  let modifiedMainFilter = MainFilter;
  let customText = null;

  // --- DODANE WARUNKI ---

  // CNC → Operator CNC
  if (MainFilter === "CNC") {
    modifiedMainFilter = "Operator CNC";
  }

  // Spawacz TIG
  if (MainFilter === "Spawacz" && SecondFilter === "141") {
    customText = "Praca spawacz tig";
  }

  // Spawacz MIG MAG
  if (
    MainFilter === "Spawacz" &&
    (SecondFilter === "135" || SecondFilter === "136")
  ) {
    customText = "Praca spawacz mig mag";
  }

  // Monter rurociągów
  if (MainFilter === "Monter" && SecondFilter === "Rurociągi") {
    customText = "Praca monter rurociągów";
  }

  // Monter kadłubów
  if (MainFilter === "Monter" && SecondFilter === "Kadłuby") {
    customText = "Praca monter kadłubów";
  }

  // Jeśli mamy customText → zwracamy go bez dalszego składania
  if (customText) {
    return (
      <div className="TranslateChoosedFiltersMainContainer">
        <h2 className="TranslatedFiltersText">{customText}</h2>
      </div>
    );
  }

  // Standardowy tekst
  const updatedParts = [
    modifiedMainFilter,
    ...headerParts.slice(1)
  ];

  const headerText = `Praca ${updatedParts.join(" ")}`;

  return (
    <div className="TranslateChoosedFiltersMainContainer">
      <h2 className="TranslatedFiltersText">{headerText}</h2>
    </div> 
  );
};

export default TranslateChoosedFilters;